import React, { useContext, useState,useEffect } from "react";
import ArchivedComponent from "./ArchivedComponent";
import { AppContext } from "context/AppContext";
import { CLAIMS_ARCHIVED } from "constant/endpoints";

function ArchivedContainer() {
  const { api, account } = useContext(AppContext);
  const [archived, setArchived] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cantElement, setCantElement] = useState(0);

  useEffect(() => {
    if (account.roles.some(role => role.name === "Admin")){
      api(CLAIMS_ARCHIVED+"?page="+currentPage).then(({ ok, body }) => {
        if (ok) {
          setArchived(body.data);
          setCantElement(body.data_size)
        }
      })
    }
    else{
      api(CLAIMS_ARCHIVED+"?search="+account.uuid+"&page="+currentPage).then(({ ok, body }) => {
        if (ok) {
          setArchived(body.data);
          setCantElement(body.data_size)
        }
      })
    }
  }, [currentPage]);

  return (
    <ArchivedComponent
      archived={archived}
      cantElement={cantElement}
      setCantElement={setCantElement}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

export default ArchivedContainer;
